import { CustomCellRendererProps } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import CountCellRenderer from '../CellRenderers/CountCellRenderer';
import InfoCellRenderer from '../CellRenderers/InfoCellRenderer';
import DamageCountView from '../DamageCountView';
import ExceptionHeaderFilter from '../Grids/ExceptionHeaderFilter';
import { dateFormatter } from '../../utils';

// const commonDefs = {}

export const columnCentered = {
  // headerClass: "text-center",
  cellStyle: {
    textAlign: 'center',
    // Add the following if you are using .ag-header-cell-menu-button
    // and column borders are set to none.
    // marginLeft: '-16px'
  },
};
export const columnDefs: ColDef[] = [
  // this row shows the row index, doesn't use any data from the row
  {
    headerName: 'ID',
    maxWidth: 100,
    hide: true,
    // field: "VIN_DETAIL_ID",
    // it is important to have node.id here, so that when the id changes (which happens
    // when the row is loaded) then the cell is refreshed.
    valueGetter: 'node.id',
  },
  {
    headerName: 'S.No.',
    maxWidth: 150,
    hide: true,
    field: 'VIN_DETAIL_ID',
    filter: 'agTextColumnFilter',
    // cellRenderer: (props: CustomCellRendererProps) => {
    //   if (props.value !== undefined) {
    //     // return props.value;
    //   } else {
    //     return (
    //       <Spinner animation="border" role="status">
    //         <span className="visually-hidden">Loading...</span>
    //       </Spinner>
    //     );
    //   }
    // },
  },
  {
    headerName: 'Date',
    headerTooltip: 'Date',
    field: 'dateTime',
    filter: 'agDateColumnFilter',
    // filter: { component: AntRangePickerFilter },
    // floatingFilter: true,

    minWidth: 220,
    cellRenderer: (props: CustomCellRendererProps) => {
      if (props.value !== undefined) {
        if (!props.value) return;
        return dateFormatter(props.value);
      } else {
        return null;
      }
    },
  },
  {
    headerName: 'VIN',
    headerTooltip: 'vin',
    filter: 'agTextColumnFilter',
    field: 'vin',
    tooltipField: 'vin',
    minWidth: 200,
    cellRenderer: 'copyRenderer', // Custom renderer for copy button
  },
  {
    headerName: 'Make',
    headerTooltip: 'make',
    tooltipField: 'make',
    field: 'make',
    filter: 'agTextColumnFilter',
    minWidth: 100,
  },
  {
    headerName: 'Model',
    headerTooltip: 'model',
    tooltipField: 'model',
    field: 'model',
    filter: 'agTextColumnFilter',
    minWidth: 100,
  },
  {
    headerName: 'Year',
    headerTooltip: 'year',
    tooltipField: 'year',
    field: 'year',
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    headerName: 'Terminal',
    headerTooltip: 'terminal',
    tooltipField: 'terminal',
    field: 'terminal',
    filter: 'agTextColumnFilter',
    minWidth: 180,
  },

  {
    headerName: 'Location',
    headerTooltip: 'location',
    tooltipField: 'location',
    filter: 'agTextColumnFilter',
    field: 'location',
    // floatingFilterComponentParams: {
    //   suppressFilterButton: false,
    // },
    minWidth: 170,
    // floatingFilterComponentParams: { suppressFilterButton: true },
    suppressFloatingFilterButton: true,
    suppressHeaderFilterButton: true,
  },
  {
    headerName: 'Count',
    headerTooltip: 'inspectionCount',
    tooltipField: 'inspectionCount',
    field: 'inspectionCount',
    // filter: 'agTextColumnFilter',
    width: 80,
    minWidth: 80,
    maxWidth: 80,
    cellRenderer: CountCellRenderer,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  {
    headerName: 'Exception',
    headerTooltip: 'damageCount',
    tooltipField: 'damageCount',
    field: 'damageCount',
    headerComponent: ExceptionHeaderFilter,
    filter: 'agTextColumnFilter',
    cellRenderer: DamageCountView,
    suppressHeaderFilterButton: false,
    floatingFilter: false, // 👈 hides input under header
    minWidth: 150,
  },
  {
    headerName: 'Info',
    headerTooltip: 'Info',
    field: 'info',
    width: 60,
    minWidth: 60,
    maxWidth: 60,
    cellClass: 'px-0 text-center',
    pinned: 'right',
    cellRenderer: InfoCellRenderer,
    // cellRenderer: InfoCircleFilled,
    sortable: false,
    filter: false,
  },
  {
    field: 'search',
    hide: true,
    filter: 'agTextColumnFilter',
  },
  {
    field: 'fromDate',
    hide: true,
    filter: 'agTextColumnFilter',
  },
  {
    field: 'toDate',
    hide: true,
    filter: 'agTextColumnFilter',
  },
];

// const InfoCircleFilled = () => {
//   return (
//     <InfoCircleFilled />
//   )
// }
